

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ModuleFormComponent } from './module-form/module-form.component';
import { ModuleComponent } from './module.component';
import { ModuleRoutes } from './module.routing';

export function declaration() {
    return [ModuleComponent, ModuleFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ModuleModule {
}

@NgModule({
    imports: [ModuleModule, ModuleRoutes],
    exports: [ModuleModule]
})
export class ModuleWithRouteModule {
}
